import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { fonts } from "../../helpers/fonts"
import { BreakPoints, media } from "../../helpers/rwd"
import arrow from "../../assets/arrow.svg"


export const ArticleContentWrapperStyles = css`
  padding: 25px 122px;
  ${media.max(BreakPoints.desktop)} {
    padding: 20px 30px;
  }
  ${media.max(BreakPoints.tablet)} {
    padding: 20px 0;
  }
`

export const TopWrapperStyles = css`
  color: ${colors.lightGray};
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
  ${media.max(BreakPoints.tablet)} {
    margin-bottom: 30px;
  }
`

export const ArrowBackNewsStyles = css`
  background: url(${arrow}) no-repeat center center;
  transform: rotate(90deg);
  width: 14px;
  height: 7px;
  margin-right: 6px;
`

export const RichTextWrapperStyles = css`
  a {
    color: ${colors.yellow};
    &:hover {
      text-decoration: underline;
    }
  }
  strong {
    font-weight: bold;
  }
  img {
    max-width: 100%;
  }
  p {
    margin: 10px 0;
    line-height: 1.5em;
    font-weight: ${fonts.weights.light};
  }
  ${media.max(BreakPoints.desktop)} {
    img {
      max-width: 100%;
    }
  }
  ${media.max(BreakPoints.tablet)} {
    p {
      margin: 20px 0;
    }
  }
  ${media.max(BreakPoints.phone)} {
    p {
      margin: 10px 0;
    }
  }
`

export const DateStyles = css`
  color: #989898
`
